// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts';

export let DirectSnapshotMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_GET_SNAPSHOT_RESPONSE)

    this.UserId = NaN;
    this.RouteId = NaN;
    this.TradableId = NaN;
    this.Bid = NaN;
    this.BidSize = NaN;
    this.Ask = NaN;
    this.AskSize = NaN;
    this.Last = NaN;
    this.LastSize = NaN;
    this.High = NaN;
    this.Low = NaN;
    this.Close = NaN;
    this.Volume = NaN;

    this.ReceivedAt = new Date();         // дата создания сообщения
}

DirectSnapshotMessage.prototype = Object.create(DirectMessageBase.prototype)